<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-start pe-5">
                    <h3 class="fw-bold my-4">Advanced Consulting and Solutions for Merchants and Traders</h3>
                    <button class="btn-blue mt-5">Free Registration</button>
                </div>
                <div class="col-md-5 text-end">
                    <img src="../../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">Our Advanced Consulting and Solutions for Merchants and Traders</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        In the fast-paced world of international and domestic trade, merchants and traders need innovative solutions, targeted strategies, and the use of advanced technologies to succeed. We provide specialized services in consulting, digitalization, market analysis, and supply chain management to help you enhance your competitiveness and uncover new opportunities in both local and global markets.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-start">
                        <h4 class="fw-bold">Merchants' Needs and Existing Challenges</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>Lack of Accurate Understanding of Target Markets:</strong> Limited access to analytical data and market trends can lead to poor decision-making.
                                </li>
                                <li class="mt-3">
                                    <strong>Logistics and Supply Chain Challenges:</strong> Transportation, goods procurement, and supply chain management are among the main challenges in trade.
                                </li>
                                <li class="mt-3">
                                    <strong>Currency Fluctuations and Changing Trade Regulations:</strong> International trade involves currency risks and evolving regulations, which can impact profitability.
                                </li>
                                <li class="mt-3">
                                    <strong>Need for Digitalization of Business Processes:</strong> Utilizing digital tools and artificial intelligence is essential for optimizing trade operations.
                                </li>
                                <li class="mt-3">
                                    <strong>Product Quality and Standards:</strong> Adhering to quality standards is essential to maintain competitiveness.
                                </li>
                                <li class="mt-3">
                                    <strong>Marketing Challenges and Attracting New Customers:</strong> Entering new markets requires strong digital marketing strategies and effective branding.
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">Our Solutions for Merchants and Traders</h3>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Market Analysis and Business Development Consulting</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Analysis of Domestic and International Markets to Identify Business Opportunities</li>
                                <li>Competitor analysis and development of competitive strategies</li>
                                <li>Formulating market entry strategies for new markets</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/Analyze.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/Business.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Digitalization and Optimization of Business Processes</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Implementing Customer Relationship Management (CRM) systems to boost sales</li>
                                <li>Automating order processing and inventory management</li>
                                <li>Intelligent solutions for demand forecasting and inventory control</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/Business.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Logistics Consulting and Supply Chain Management</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Providing optimized solutions for transportation and distribution</li>
                                <li>Reducing supply chain costs through innovative technologies</li>
                                <li>Smart solutions for tracking and managing inventory</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/img11.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Financial, Currency, and Risk Management Consulting for International Trade</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Analyzing and managing currency risks to minimize the impact of market fluctuations</li>
                                <li>Financing and investment strategies in international markets</li>
                                <li>Solutions for liquidity management and optimization of cash flow</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/img11.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Branding and Digital Marketing for International Trade</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Developing international marketing strategies to attract foreign customers</li>
                                <li>Creating digital advertising campaigns to increase brand visibility</li>
                                <li>Optimizing websites and SEO to attract customers worldwide</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img21.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/contract.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Legal Consulting and Commercial Contract Drafting</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Drafting and reviewing international commercial contracts</li>
                                <li>Consulting on commercial law and compliance with export and import regulations</li>
                                <li>Solutions for managing commercial disputes and conflict resolution</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/contract.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Training and Empowerment for Merchants and Traders</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Conducting specialized workshops on e-commerce and exports</li>
                                <li>Training in business negotiation skills and principles of international trade</li>
                                <li>Offering dedicated courses to optimize buying and selling strategies</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/learning.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start d-md-block d-none">
                        <img src="../../../assets/services-img/Business2.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Technology Solutions for Smart Trade</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Implementing artificial intelligence for market trend analysis</li>
                                <li>Utilizing blockchain for securing commercial contracts</li>
                                <li>Data-driven solutions for fast and optimized decision-making</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/Business2.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-start">Results and Value Creation for Merchants and Traders</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/precision.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Increased Accuracy in Business Decision-Making</strong> through precise market analysis
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/production.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Reduced Logistics and Supply Chain Costs</strong> through innovative logistics management solutions
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Increased Profitability and Reduced Currency Risks</strong> with smart financial strategies
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Increased Profitability and Reduced Currency Risks</strong> through intelligent financial strategies
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/img21.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Improved Marketing and Greater Customer Acquisition</strong> through digitalization and targeted advertising
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/market.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Business Growth and Entry into International Markets</strong> with customized commercial strategies
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>FAQ</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-start">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>How Can I Benefit from Your Services for My Business?</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-start" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-start" style="line-height: 35px !important;">
                        You can contact our consulting team to discuss your needs. After a thorough assessment, we will provide tailored solutions to meet your requirements.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>Are these services suitable for small businesses as well?</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                       Yes, we design solutions for all business levels, from small companies to large-scale merchants.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6>Does your consulting service include implementation support as well?</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, in addition to providing consulting, we will support you in implementing the proposed solutions.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                     <h6>How can I reduce currency risks in my business?</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        We offer financial strategies and risk hedging solutions that help you manage currency fluctuations effectively.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>Is it possible to receive specialized consulting in the field of digital marketing?</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, we provide specialized services in digital marketing to enhance visibility and attract customers.
                        <br>
                        We are here to support you in taking your business to the next level. For consultation and more information, please get in touch with us.../
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
*{
    direction: ltr;
}
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  right: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  right: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>